import { ReactNode } from "react";
import ReactTooltip from "react-tooltip";

import { MapFilterButton } from "../MapFilterButton";

import { Wrapper } from "./styles";

export type FilterOption = {
  [key: string]: {
    icon: ReactNode;
    active: boolean;
    tooltip?: string;
  };
};

type Props = {
  filters: FilterOption;
  onFilterChange: (filtersChanged: FilterOption) => void;
};

function MapMenu({ filters, onFilterChange }: Props) {
  function onFilterClick(id: string) {
    filters[id].active = !filters[id].active;
    onFilterChange(filters);
  }

  return (
    <Wrapper>
      {Object.keys(filters).map((key) => {
        const filter = filters[key];

        return (
          <MapFilterButton
            key={key}
            onClick={() => {
              onFilterClick(key);
            }}
            selected={filter.active}
            icon={filter.icon}
            tooltip={filter.tooltip}
          />
        );
      })}

      <ReactTooltip
        id="mapFilter"
        place="left"
        type="dark"
        effect="solid"
        className="tooltip"
        backgroundColor={"var(--black-400)"}
      />
    </Wrapper>
  );
}

export { MapMenu };
